import WithRender from "./DesignIcon.html";

export default WithRender({});
